import Api from "../../../util/Api";

export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Összevonás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'mergePatients'
            }
        ],
        rowActions: [
        ],
        searchFields: [
            {
                name: "name",
                label: "Név",
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "prefixedId",
                label: "Technikai azonosító",
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "phoneNumber",
                label: "Telefonszám",
                formType: "tel",
                formSize: 3,
                formVisible: true
            },
            {
                name: "email",
                label: "E-mail",
                formType: "email",
                formSize: 3,
                formVisible: true
            },
            {
                name: "dateOfBirth",
                label: "Születés dátuma",
                formType: "date",
                formSize: 3,
                formVisible: true
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ",
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "documentType",
                label: "Okmány típus",
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getDocumentTypeOptions,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                formVisible: true
            },
            {
                name: "documentNumber",
                label: "Okmány száma",
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "signCode",
                label: "Szignó kód",
                formType: "text",
                formSize: 3,
                formVisible: true
            }
        ],
        headerFields: [
            {
                name: "name",
                label: "Név",
                sort: true,
                formRequired: true,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "prefixedId",
                label: "Technikai azonosító",
                sort: true,
                formRequired: true,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "phoneNumber",
                label: "Telefonszám",
                sort: true,
                formRequired: true,
                formType: "tel",
                formSize: 3,
                formVisible: true
            },
            {
                name: "email",
                label: "E-mail",
                sort: true,
                visibility: false,
                formRequired: true,
                formType: "email",
                formSize: 3,
                formVisible: true
            },
            {
                name: "birthName",
                label: "Születési név",
                sort: true,
                visibility: false,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "motherName",
                label: "Anyja neve",
                sort: true,
                visibility: false,
                formRequired: true,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "placeOfBirth",
                label: "Születési hely",
                sort: true,
                visibility: false,
                formRequired: true,
                formType: "text",
                formSize: 4,
                formVisible: true
            },
            {
                name: "dateOfBirth",
                label: "Születés dátuma",
                slot_name: "date_format",
                sort: true,
                formRequired: true,
                formType: "date",
                formSize: 3,
                formVisible: true,
            },
            {
                name: "patientAge",
                label: "Életkor",
                visibility: false,
                formType: "number",
                formReadOnly: true,
                formSize: 1,
                formVisible: true
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ",
                sort: true,
                formRequired: true,
                formType: "text",
                formSize: 4,
                formVisible: true,
            },
            {
                name: "documentType",
                label: "Okmány típus",
                sort: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getDocumentTypeOptions,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                formVisible: true,
            },
            {
                name: "documentNumber",
                label: "Okmány száma",
                sort: true,
                formRequired: false,
                formType: "text",
                formSize: 3,
                formVisible: true,
            },
            {
                name: "sosNumber",
                label: "S.O.S. szám",
                sort: true,
                visibility: false,
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "sex",
                label: "Nem",
                sort: true,
                visibility: false,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getSexOptions,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                formVisible: true
            },
            {
                name: "nationality",
                label: "Állampolgárság",
                visibility: false,
                formSize: 3,
                formVisible: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getCountryExtendedOptions,
                    formatText: function (val) {
                        return val.nationality;
                    },
                    formatOption: function (val) {
                        return val.nationality;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'nationality',
                    returnValue: 'nationality',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "healthInsurance",
                label: "EÜ biztosító",
                visibility: false,
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "publicHealthCareCardNumber",
                label: "Közgyógyellátási igazolvány száma",
                visibility: false,
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "publicHealthCareCardValidity",
                label: "Közgyógyellátási igazolvány érvényessége",
                visibility: false,
                formType: "date",
                formSize: 3,
                formVisible: true
            },
            {
                name: "address",
                visibility: false,
                formType: 'address',
                formVisible: true
            },
            {
                name: "patientStatusId",
                label: "Páciens státusza",
                formVisible: true,
                visibility: false,
                formSize: 2,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getPatientStatus,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "student",
                label: "Diák?",
                formVisible: true,
                visibility: false,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "seeEvidenceAsFeu",
                label: "FEÜ orvos láthatja szakorvosi dokumentumokat?",
                formVisible: true,
                visibility: false,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "seeFeuEvidenceAsDoctor",
                label: "Orvos láthatja FEÜ szakorvosi dokumentumokat?",
                formVisible: true,
                visibility: false,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "foreignPatient",
                label: "Külföldi?",
                formType: "checkbox",
                formSize: 2,
                formVisible: true,
                visibility: false
            },
            {
                name: "payments",
                label: "Fizetési mód",
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getFizetesiModListToSelect,
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                visibility: false,
                formVisible: true
            },
            {
                name: "insurances",
                label: "Biztosító",
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getPartnersToSelect,
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                visibility: false,
                formVisible: true
            },
            {
                name: "signCode",
                label: "Szignó kód",
                sort: true,
                visibility: false,
                formRequired: true,
                formType: "text",
                formSize: 4,
                formVisible: true
            },
            {
                name: "note",
                label: "Megjegyzés",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "createdBy",
                label: "createdBy",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "createdOn",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "deleted",
                label: "deleted",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "clientCode",
                label: "clientCode",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "membershipFee",
                label: "membershipFee",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "membershipExpirationDate",
                label: "membershipExpirationDate",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "membershipType",
                label: "membershipType",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "oldId",
                label: "oldId",
                sort: true,
                visibility: false,
                formVisible: false
            },
        ]
    }
}
